if (!customElements.get('td-cart-drawer')) {
    class TdCartDrawer extends HTMLElement {
        constructor() {
            super();
            const debounce = (fn, wait) => {
              let t;
              return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
              };
            }
            this.htmlSelector = document.querySelector('html')
            this.cartTrigger = document.getElementById('cart-drawer-toggle')
            
            if(this.cartTrigger) this.cartTrigger.addEventListener('click', this.toggleDrawer.bind(this))
            this.updateFreeShipping();

            this.debouncedOnChange = debounce((event) => {
                this.onChange(event);
            }, 300);
           
            this.addEventListener('change', this.debouncedOnChange.bind(this))
            
            this.removeProductEvent();
            this.notesToggle();
            this.setDiscountForm();
            this.slider = this.querySelector('.td-cart-drawer__recommended-slider-wrapper');
            this.addEventListener('addToCart', function() {
                this.openDrawer()
                this.removeProductEvent();
                this.updateFreeShipping();
                this.notesToggle();
                this.setDiscountForm();
            });
            
            
        }
        connectedCallback() {
          this.wishlistAddEvent()
        }
        renderContents(parsedState) {
          this.getSectionsToRender().forEach((section => {
            if (!document.getElementById(section.id)) {
              return;
            }
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            this.removeProductEvent();
            this.updateFreeShipping();
            this.updateSwiperSlides();
            this.notesToggle();
            this.setDiscountForm();             
            return
          
          }));
        }
        reRenderCart(productId = false, value = false) {
          const payload = {};
          payload.sections = this.getSectionsToRender().map((section) => section.section);
          if(productId && value ){
            payload.updates = {};
            payload.updates[productId] = value;
          }
          return fetch(`${theme.routes.cart_update_url}`,  {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': `application/json`
            },
            body: JSON.stringify(payload),
          })
            .then((response) => response.json())
            .then((response) => {
              this.renderContents(response);             
            });
        }
        wishlistAddEvent() {
          document.addEventListener('status:cart:add', ({detail}) => {
            if(detail) {
            const { items } = detail
            
              if(items?.length > 0) {
                  const item = items[0]
                  if(item) {  
                  this.reRenderCart(item.variant_id, item.quantity)
                  }
                }
            }
            
          })
        }
        openDrawer() {
            document.body.classList.add('open-cc');
            document.body.classList.add('open-cart');
            this.htmlSelector.classList.add('overflow-hidden')
            this.classList.add('active');
            this.focus();
            this.updateSwiperSlides();
        }
        toggleDrawer(event) {
            event.preventDefault()
            const path = window.location.pathname
            if(path == '/cart') return
            document.body.classList.add('open-cc');
            document.body.classList.add('open-cart');
            this.htmlSelector.classList.add('overflow-hidden')
            this.classList.add('active');
            this.focus();
            this.updateSwiperSlides();
        }
        onChange(event) {
            if (event.target.classList.contains('qty')) {
              this.updateQuantity(event.target.dataset.index, event.target.value, event.target);              
            }
          }
        removeProductEvent() {
          let removes = this.querySelectorAll('.remove');
          if(removes.length) {
              removes.forEach((remove) => {
                  remove.addEventListener('click', (event) => {
                    this.updateQuantity(event.target.dataset.index, '0');
            
                    event.preventDefault();
                  });
                });
          }
      
        }

        setDiscountForm() {
          const discountForm = document.querySelector(".cart-drawer__discount-form");
          if (!discountForm) return;
        
          const discountFormToggle = discountForm.querySelector("[data-action='reveal-discount']");
          const discountFormAction = discountForm.querySelector("[data-action='apply-discount']");
        
          if (!discountFormToggle || !discountFormAction) return; 
        
          discountFormToggle.addEventListener('click', () => {
            discountFormToggle.classList.add('active');
          });
        
          discountFormAction.addEventListener('click', async () => { 
            discountForm.classList.add('thb-loading');
            await this.applyDiscount();
          });
        }

        async applyDiscount() {
          const discountFormInput = document.querySelector("[data-action='discount-input']")?.value;
          if (!discountFormInput) return;
        
          const discountApplyUrl = "/discount/" + discountFormInput; 
        
          try {
            await fetch(discountApplyUrl);
            const response = await fetch("/cart.js");
            const cart = await response.json();        
            let discountApplied = false;
            cart.cart_level_discount_applications.forEach((discount) => {
              if (discount.title === discountFormInput) { 
                this.reRenderCart(false, false);
                discountApplied = true;
                return;
              }
            });
        
            if (!discountApplied) {
              this.discountFormErrorHandler();
            }
          } catch (err) {
            console.error("Error:", err);
            this.discountFormErrorHandler();
          } finally {
            document.querySelector(".cart-drawer__discount-form")?.classList.remove('thb-loading');
          }
        }

        discountFormErrorHandler() {
          document.querySelector("[data-action='discount-input']").value = "";
          document.querySelector("[data-action='discount-input']").focus();
          const discountError = document.querySelector('.cart-drawer__discount-form__error-message');
          if (discountError) {
            discountError.classList.add('active');
            setTimeout(() => discountError?.classList.remove('active'), 4000);
          }
        }

        notesToggle() {
            let notes_toggle = document.getElementById('order-note-toggle');
        
            if (!notes_toggle) {
              return;
            }
        
            notes_toggle.addEventListener('click', (event) => {
              notes_toggle.nextElementSibling.classList.add('active');
            });
            notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
              el.addEventListener('click', (event) => {
                notes_toggle.nextElementSibling.classList.remove('active');
                this.saveNotes();
              });
            });
          }
          saveNotes() {
            fetch(`${theme.routes.cart_update_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': `application/json`
              },
              body: JSON.stringify({
                'note': document.getElementById('mini-cart__notes').value
              })
            });
          }
       
        getSectionsToRender() {
            return [{
              id: 'Td-Cart-Drawer',
              section: 'td-cart-drawer',
              selector: '.cart-drawer'
            },
            {
              id: 'cart-drawer-toggle',
              section: 'cart-bubble',
              selector: '.thb-secondary-item-icon'
            }
          ];
        }
        getSectionInnerHTML(html, selector) {
          return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
        }   
        updateFreeShipping() {
        
          const free_shipping = this.querySelector('.free-shipping');
         
          if (free_shipping) {
            let amount_text = free_shipping.querySelector('.free-shipping--text span');
            let total = parseInt(free_shipping.dataset.cartTotal, 10);
            let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
            let percentage = 1;
    
            if (total < minimum) {
              percentage = total / minimum;
      
              if (amount_text) {
                  let remaining = minimum - total,
                  format = window.theme.settings.money_with_currency_format || "${{amount}}";
                  amount_text.innerHTML = formatMoney(remaining, format);
              }
            }
    
            free_shipping.style.setProperty('--percentage', percentage);
           
          }
        }
        updateSwiperSlides() {
          const slider = document.querySelector('.td-cart-drawer__recommended-slider-wrapper')
          const slides = Array.from(document.querySelectorAll('.td-cart-drawer__recommended__slide')) 
              if(slides.length === 0) {                
              
                if(slider) slider.classList.add('td-hide')
              
              }else {
                if(slider) slider.classList.remove('td-hide')
              }
        }
        updateQuantity(line, quantity, selector) {
        this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
        if(this.querySelector('.td-cart-drawer__error')) this.querySelector('.td-cart-drawer__error').style.display = 'none';
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
    
        dispatchCustomEvent('line-item:change:start', {
            quantity: quantity
        });
        if (this.querySelector('.product-recommendations--full')) {
            this.querySelector('.product-recommendations--full').classList.remove('active');
        }
        fetch(`${theme.routes.cart_change_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': `application/json`
            },
            ...{
                body
            }
            })
            .then((response) => response.json())
            .then((response) => {
              if (response.errors) {  
                const errorElm = this.querySelector('.td-cart-drawer__error');       
                if(errorElm) {
                  errorElm.textContent = response.errors;
                  errorElm.style.display = 'block';
                }
                if(selector) {
                  selector.value = selector.value - 1
                }
              } else {    
                this.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document
                      .getElementById(section.id)
                      .querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    response.sections[section.section],
                    section.selector
                  );
                });
    
                dispatchCustomEvent("line-item:change:end", {
                  quantity: quantity,
                  cart: response,
                });
              }
            }).finally(() => {    
              if (this.querySelector(`#CartDrawerItem-${line}`)) {
                this.querySelector(`#CartDrawerItem-${line}`).classList.remove(
                  "thb-loading"
                );
              }
              this.removeProductEvent();
              this.updateFreeShipping();
              this.updateSwiperSlides();
              this.notesToggle();
              this.setDiscountForm();
            })
            .catch(err => {
              console.log("err: ", err);
              if(err) {
                  if(this.querySelector(`#CartDrawerItem-${line}`)) {
                    this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
                  }
                  
              }
            });
        }
    }
    customElements.define('td-cart-drawer', TdCartDrawer);
}